import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
// import {useParams} from 'react-router-dom';

import Select from './../../common/components/Select';

import DatabaseService from './../../services/DatabaseService';
import SearchService from './../../services/SearchService';

// import {LAYOUT_SM, LAYOUT_XS } from './../config';


const Wrapper = styled.div.withConfig({displayName:'-Wrapper'})`
	position: absolute;
	top: 0px;
	left: 0px;
	width: 550px;
	height: 100%;
`;
const Mover = styled.div.withConfig({displayName:'-Mover'})`
	position: absolute;
  top: 0px;
  left: 0px;
  left: calc(100% * -${props => props.isMoved});
  width: calc(100% * 2);
  height: 100%;
  display: flex;
  flex-direction: row;

  -webkit-transition: all 0.15s ease-in-out;
  -moz-transition: all 0.15s ease-in-out;
  -ms-transition: all 0.15s ease-in-out;
  -o-transition: all 0.15s ease-in-out;
  transition: all 0.15s ease-in-out;
`;
const SearchPage = styled.div.withConfig({displayName:'-SearchPage'})`
	position: absolute;
	top: 0px;
	left: 0px;
	width: 550px;
	height: 100%;
	display: flex;
  flex-direction: column;
`;
const LayersPage = styled.div.withConfig({displayName:'-LayersPage'})`
	position: absolute;
	top: 0px;
	left: 550px;
	width: 550px;
	height: 100%;
	display: flex;
  flex-direction: column;
`;

const Topbar = styled.div.withConfig({displayName:'-Topbar'})`
	position: relative;
	background-color: #0d609d;
	color: #ffffff;
	padding: 8px;
	text-align: center;
	flex-grow: 0;
	flex-shrink: 0;
`;
const TopbarTitle = styled.div.withConfig({displayName:'-TopbarTitle'})`
	font-size: 17px;
	font-weight: 500;
`;
const TopbarClose = styled.div.withConfig({displayName:'-TopbarClose'})`
	position: absolute;
	top: 6px;
	right: 14px;
	font-size: 20px;
	font-weight: 500;
	cursor: pointer;
	width: 26px;
	height: 26px;
`;
const List = styled.div.withConfig({displayName:'-List'})`
	flex-grow: 1;
	flex-shrink: 1;
	overflow-y: auto;
`;
const Table = styled.table.withConfig({displayName:'-Table'})`
	width: 100%;
	border-spacing: 0px;
	border: 0px;
	position: relative;

	& th,
	& td{
		border-bottom: 1px solid #c4c4c4;
		padding: 14px;
		text-align: left;
		height: 53px;
		position: relative;
		// cursor: pointer;
	}
	& th{
		background-color: #f4f4f4;
		font-size: 11px;
		position: sticky;
		z-index: 100;
		top: 0;

	}
	& td{
		position: relative;
		font-size: 13px;
	}

`;
const Macro = styled.tr.withConfig({displayName:'-Macro'})`
	background-color: #E3E3E3;
	border-bottom: 1px solid #C4C4C4;
	color: #555555;
	font-size: 11px;
	line-height: 14px;
	padding: 7px;

	& td{
		height: auto;
		padding: 7px 14px;
		font-weight: bold;
		font-size: 11px;
	}
`;
const Check = styled.td.withConfig({displayName:'-Check'})`
	color: ${props => props.active ? "#0d609d" : "#F9F9F9"};
	font-size: 13px;
	padding-left: 14px;
`;



const SearchForm = styled.div.withConfig({displayName:'-SearchForm'})`
	background-color: #164886;
  padding: 10px;
  color: #ffffff;
  font-size: 12px;
`;
const SearchRow = styled.div.withConfig({displayName:'-SearchRow'})`
	display: flex;
  flex-direction: row;
  margin-bottom: 20px;
	gap: 8px;
`;
const SearchElement = styled.div.withConfig({displayName:'-SearchElement'})`
	flex-grow: 0;
	flex-shrink: 0;
	flex-basis: ${props => props.size === "3" ? "100%" : "calc(100% / 3)"};
`;
const SearchLabel = styled.label`
	display: block;
  margin-bottom: 0.5rem;
`;
const SearchSelectGroup = styled.div.withConfig({displayName:'-SearchSelectGroup'})`
	display: flex;
	flex-direction: row;

	& > div:nth-child(1){
		flex-grow: 0;
		flex-shrink: 0;
	}
	& > div:nth-child(2){
		flex-grow: 1;
		flex-shrink: 1;
	}

	& > div:not(:first-child) > div > div{
		border-top-left-radius: 0px;
		border-bottom-left-radius: 0px;
		border-left: 0px;
	}
	& > div:not(:last-child) > div > div{
		border-bottom-right-radius: 0px;
		border-top-right-radius: 0px;
	}
`;


const Color = styled.div.withConfig({displayName:'-Color'})`
	background-color: ${props => props.color === 1 ? "#33be00" : props.color === 2 ? "#ffbb39" : props.color === 3 ? "#ff0000" : props.color === 0 ? "#ffffff" : "transparent"};
	border: 1px solid ${props => props.color === 1 ? "#33be00" : props.color === 2 ? "#ffbb39" : props.color === 3 ? "#ff0000" : props.color === 0 ? "#dedede" : "transparent"};
	width: 10px;
	height: 10px;
	border-radius: 10px;
	display: inline-block;
	margin-right: 5px;
`;


const SearchResults = styled.div.withConfig({displayName:'-SearchResults'})`
	height: calc(100vh - 200px);
	overflow-x: hidden;
	overflow-y: auto;
`;
const NoResult = styled.div.withConfig({displayName:'-NoResult'})`
	text-align: center;
	margin-top: 30px;
`;


const ResultsTable = styled.table.withConfig({displayName:'-ResultsTable'})`
	width: 100%;
	border-spacing: 0px;
	border: 0px;
	position: relative;

	& th,
	& td{
		border-bottom: 1px solid #c4c4c4;
		text-align: left;
		position: relative;
		// cursor: pointer;
	}
	& th{
		background-color: #f4f4f4;
		font-size: 11px;
		top: 0;
		padding: 7px 14px;

	}
	& td{
		position: relative;
		font-size: 13px;
		border-bottom: 1px solid #C4C4C4;
		border-right: 1px solid #C4C4C4;
		padding: 1px 14px;
	}

	/*
	& td:last-child{
		border-bottom: 1px solid #666;
	}*/
`;
const TrMacrolotto = styled.tr.withConfig({displayName:'-TrMacrolotto'})`
	& td{
		color: #ffffff;
		background-color: #609dff;
	}
`;
const TdTerreno = styled.td.withConfig({displayName:'-TdTerreno'})`
	&::before{
		position: absolute;
		top: 0px;
		left: 0px;
		height: 100%;
		width: 20px;
		background-color: #dedede;

		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 12px;
		color: #999;
		content: "T";
	}
	height: 23px;
	padding-left: 27px !important;
`;
const TdEluato = styled.td.withConfig({displayName:'-TdEluato'})`
	&::before{
		position: absolute;
		top: 0px;
		left: 0px;
		height: 100%;
		width: 20px;
		background-color: #dedede;

		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 12px;
		color: #999;
		content: "E";
	}
	height: 23px;
	padding-left: 27px !important;
`;


const NoWrap = styled.span`
	white-space: nowrap;
`;


const Side = ({
	onClose,
	showSearch,
	showLayers,
	idSito,
	showListLv1,
	setShowListLv1,
	showListLv2,
	setShowListLv2,
	showListCartografie,
	setShowListCartografie,
	mapType,
	setMapType,
	fullListLv1,
	fullListLv3,
	fullListLv4
}) => {

	const [macrolotti, setMacrolotti] = useState([]);
	const [subaree, setSubaree] = useState([]);
	const [parametri, setParametri] = useState([]);

	const [searchIdMacrolotto, setSearchIdMacrolotto] = useState(null);
	const [searchColorSondaggio, setSearchColorSondaggio] = useState(null);
	const [searchIdSondaggio, setSearchIdSondaggio] = useState(null);
	const [searchColorCampione, setSearchColorCampione] = useState(null);
	const [searchIdCampione, setSearchIdCampione] = useState(null);
	const [searchColorParametro, setSearchColorParametro] = useState(null);
	const [searchIdParametro, setSearchIdParametro] = useState(null);

	const [searchResult, setSearchResult] = useState(null);
	const [pending, setPending] = useState(false)

	const filtersAreEmpty = () => !searchIdMacrolotto && !searchColorSondaggio && !searchIdSondaggio && !searchColorCampione && !searchIdCampione && !searchColorParametro && !searchIdParametro

	useEffect(() => {
		DatabaseService.listMacrolotti(idSito).then((response) => {
				setMacrolotti(response);
		});
		DatabaseService.listSubaree().then((response) => {
			setSubaree(response);
		});
		DatabaseService.listParametri().then((response) => {
			setParametri(response);
		});

	}, [idSito]);

	useEffect(() => {

		if (filtersAreEmpty()) {
			setSearchResult([])
		}
		else {
			setPending(true)
			SearchService.search(
				(searchIdMacrolotto ? "macrolottoId:"+searchIdMacrolotto+" && " : "") +
				(searchColorSondaggio != null ? "coloreSondaggio:"+searchColorSondaggio+" && " : "") +
				(searchIdSondaggio ? "sondaggioId:"+searchIdSondaggio+" && " : "") +
				(searchColorCampione != null ? "coloreCampione:"+searchColorCampione+" && " : "") +
				(searchIdCampione ? "campioneId:"+searchIdCampione+" && " : "") +
				(searchColorParametro != null ? "coloreDato:"+searchColorParametro+" && " : "") +
				(searchIdParametro ? "parametroId:"+searchIdParametro+" && " : "") +
				"obj_type:VALUE"
			).then((response) => {
				let result = {};
				response.forEach(group => {
					group.hits.forEach(element => {
						if(!result[element.document.siglaMacrolotto]){
							result[element.document.siglaMacrolotto] = {};
						}
						result[element.document.siglaMacrolotto]["nome"] = element.document.siglaMacrolotto;

						if(!result[element.document.siglaMacrolotto]["sondaggi"]){
							result[element.document.siglaMacrolotto]["sondaggi"] = {};
						}
						if(!result[element.document.siglaMacrolotto]["sondaggi"][element.document.siglaSondaggio]){
							result[element.document.siglaMacrolotto]["sondaggi"][element.document.siglaSondaggio] = {};
						}
						result[element.document.siglaMacrolotto]["sondaggi"][element.document.siglaSondaggio]["id"] = element.document.sondaggioId;
						result[element.document.siglaMacrolotto]["sondaggi"][element.document.siglaSondaggio]["nome"] = element.document.siglaSondaggio;
						result[element.document.siglaMacrolotto]["sondaggi"][element.document.siglaSondaggio]["colore"] = element.document.coloreSondaggio;

						if(!result[element.document.siglaMacrolotto]["sondaggi"][element.document.siglaSondaggio]["campioni"]){
							result[element.document.siglaMacrolotto]["sondaggi"][element.document.siglaSondaggio]["campioni"] = {};
						}
						if(!result[element.document.siglaMacrolotto]["sondaggi"][element.document.siglaSondaggio]["campioni"][element.document.siglaCampione]){
							result[element.document.siglaMacrolotto]["sondaggi"][element.document.siglaSondaggio]["campioni"][element.document.siglaCampione] = {};
						}
						result[element.document.siglaMacrolotto]["sondaggi"][element.document.siglaSondaggio]["campioni"][element.document.siglaCampione]["id"] = element.document.idCampione;
						result[element.document.siglaMacrolotto]["sondaggi"][element.document.siglaSondaggio]["campioni"][element.document.siglaCampione]["nome"] = element.document.siglaCampione;
						result[element.document.siglaMacrolotto]["sondaggi"][element.document.siglaSondaggio]["campioni"][element.document.siglaCampione]["colore"] = element.document.coloreCampione;


						if(!result[element.document.siglaMacrolotto]["sondaggi"][element.document.siglaSondaggio]["campioni"][element.document.siglaCampione]["datiT"]){
							result[element.document.siglaMacrolotto]["sondaggi"][element.document.siglaSondaggio]["campioni"][element.document.siglaCampione]["datiT"] = {};
						}
						if(!result[element.document.siglaMacrolotto]["sondaggi"][element.document.siglaSondaggio]["campioni"][element.document.siglaCampione]["datiE"]){
							result[element.document.siglaMacrolotto]["sondaggi"][element.document.siglaSondaggio]["campioni"][element.document.siglaCampione]["datiE"] = {};
						}

						let matrice = element.document.has_terreno ? "T" : "E";
						if(!result[element.document.siglaMacrolotto]["sondaggi"][element.document.siglaSondaggio]["campioni"][element.document.siglaCampione]["dati"+matrice][element.document.parametroId]){
							result[element.document.siglaMacrolotto]["sondaggi"][element.document.siglaSondaggio]["campioni"][element.document.siglaCampione]["dati"+matrice][element.document.parametroId] = {};
						}
						result[element.document.siglaMacrolotto]["sondaggi"][element.document.siglaSondaggio]["campioni"][element.document.siglaCampione]["dati"+matrice][element.document.parametroId]["id"] = element.document.parametroId;
						result[element.document.siglaMacrolotto]["sondaggi"][element.document.siglaSondaggio]["campioni"][element.document.siglaCampione]["dati"+matrice][element.document.parametroId]["nome"] = element.document.parametro;
						result[element.document.siglaMacrolotto]["sondaggi"][element.document.siglaSondaggio]["campioni"][element.document.siglaCampione]["dati"+matrice][element.document.parametroId]["valore"] = element.document.valore;
						result[element.document.siglaMacrolotto]["sondaggi"][element.document.siglaSondaggio]["campioni"][element.document.siglaCampione]["dati"+matrice][element.document.parametroId]["colore"] = element.document.coloreDato;


					});


				});

				setSearchResult(result)
				setPending(false)
			})
		}

    }, [idSito, searchIdMacrolotto, searchColorSondaggio, searchIdSondaggio, searchColorCampione, searchIdCampione, searchColorParametro, searchIdParametro]);


  return (
    <Wrapper>
			<Mover isMoved={showSearch ? 0 : 1}>
				<SearchPage>
					<Topbar>
						<TopbarTitle>Ricerca</TopbarTitle>
						<TopbarClose onClick={() => onClose()}><i className="fas fa-times" /></TopbarClose>
					</Topbar>
					<SearchForm>

						<SearchRow>
              <SearchElement size="3">
                <SearchLabel>Macrolotto:</SearchLabel>
								<Select
									maxHeight={"200px"}
									variant={"blue"}
									values={[{
														"name": <i></i>,
														"value": null,
													}].concat(fullListLv1.map((item) => ({
										"name": item.siglaMacrolotto + (item.descrizione ? " - " + item.descrizione : ""),
										"value": item.id
									})))}
									width={"100%"}
									selected={searchIdMacrolotto}
									onChange={(val) => setSearchIdMacrolotto(val)}
								/>
              </SearchElement>
            </SearchRow>
            <SearchRow>
              <SearchElement size="1">
                <SearchLabel>Sondaggio:</SearchLabel>
                <SearchSelectGroup>
									<Select
										maxHeight={"200px"}
										variant={"blue"}
										values={[{
											"name": "",
											"value": null,
										},{
											"name": <Color color={1} />,
											"value": 1,
										},{
											"name": <Color color={2} />,
											"value": 2,
										},{
											"name": <Color color={3} />,
											"value": 3,
										}]}
										width={"60px"}
										selected={searchColorSondaggio}
										onChange={(val) => setSearchColorSondaggio(val)}
									/>
                  					<Select
										maxHeight={"200px"}
										variant={"blue"}
										values={[{
											"name": <i></i>,
											"value": null,
											}].concat(
												fullListLv3
													.filter(item => Boolean(item.siglaSondaggio))
													.map((item) => ({
														"name": item.siglaSondaggio + (item.descrizione ? " - " + item.descrizione : ""),
														"value": item.id
													}))
											)
										}
										width={"100%"}
										selected={searchIdSondaggio}
										onChange={(val) => setSearchIdSondaggio(val)}
									/>
                </SearchSelectGroup>
              </SearchElement>
              <SearchElement size="1">
                <SearchLabel>Campione:</SearchLabel>
                <SearchSelectGroup>
									<Select
										maxHeight={"200px"}
										variant={"blue"}
										values={[{
											"name": "",
											"value": null,
										},{
											"name": <Color color={1} />,
											"value": 1,
										},{
											"name": <Color color={2} />,
											"value": 2,
										},{
											"name": <Color color={3} />,
											"value": 3,
										}]}
										width={"60px"}
										selected={searchColorCampione}
										onChange={(val) => setSearchColorCampione(val)}
									/>
                  <Select
										maxHeight={"200px"}
										variant={"blue"}
										values={[{
                              "name": <i></i>,
                              "value": null,
                            }].concat(fullListLv4
								.filter(item => Boolean(item.siglaCampione))
								.map((item) => ({
											"name": item.siglaCampione + (item.descrizione ? " - " + item.descrizione : ""),
											"value": item.id
										})))}
										width={"100%"}
										selected={searchIdCampione}
										onChange={(val) => setSearchIdCampione(val)}
									/>
                </SearchSelectGroup>
              </SearchElement>
              <SearchElement size="1">
                <SearchLabel>Parametro:</SearchLabel>
                <SearchSelectGroup>
									<Select
										maxHeight={"200px"}
										variant={"blue"}
										values={[{
											"name": "",
											"value": null,
										},{
											"name": <Color color={0} />,
											"value": 0,
										},{
											"name": <Color color={1} />,
											"value": 1,
										},{
											"name": <Color color={2} />,
											"value": 2,
										},{
											"name": <Color color={3} />,
											"value": 3,
										}]}
										width={"60px"}
										selected={searchColorParametro}
										onChange={(val) => setSearchColorParametro(val)}
									/>
                  <Select
										maxHeight={"200px"}
										variant={"blue"}
										values={[{
                              "name": <i></i>,
                              "value": null,
                            }].concat(parametri.map((item) => ({
											"name": item.nome,
											"value": item.id
										})))}
										width={"100px"}
										selected={searchIdParametro}
										onChange={(val) => setSearchIdParametro(val)}
										optionWidth={"300px"}
									/>
                </SearchSelectGroup>
              </SearchElement>
            </SearchRow>

					</SearchForm>
					<SearchResults>

						{pending
							? <NoResult>Caricamento...</NoResult>
							:

								(!searchIdMacrolotto && !searchColorSondaggio && !searchIdSondaggio && !searchColorCampione && !searchIdCampione && !searchColorParametro && !searchIdParametro)
									? <NoResult>Filtra per vedere i risultati.</NoResult>
									:
										Object.keys(searchResult).length > 0 ?
											<ResultsTable>
												<thead>
													<tr>
														<th width="90px">Sondaggio</th>
														<th width="90px">Campione</th>
														<th>Parametro</th>
													</tr>
												</thead>
												<tbody>
													{Object.keys(searchResult).map((keyMacrolotto) => {
														return <React.Fragment key={keyMacrolotto}>
															<TrMacrolotto>
																<td colSpan="3">
																	{searchResult[keyMacrolotto]["nome"]}
																</td>
															</TrMacrolotto>
															{Object.keys(searchResult[keyMacrolotto]["sondaggi"]).map((keySondaggio, iSondaggio) => {

																return Object.keys(searchResult[keyMacrolotto]["sondaggi"][keySondaggio]["campioni"]).map((keyCampione, iCampione) => {
																	return <React.Fragment key={keyMacrolotto+"-"+keyCampione+"-"+keySondaggio}>
																			<tr>
																				{iCampione === 0 ?
																					<td rowSpan={Object.keys(searchResult[keyMacrolotto]["sondaggi"][keySondaggio]["campioni"]).length*2}>
																						<NoWrap>
																							<Color color={searchResult[keyMacrolotto]["sondaggi"][keySondaggio]["colore"]} />
																							{searchResult[keyMacrolotto]["sondaggi"][keySondaggio]["nome"]}
																						</NoWrap>
																					</td>
																				: null }
																				<td rowSpan={2}>
																					<NoWrap>
																						<Color color={searchResult[keyMacrolotto]["sondaggi"][keySondaggio]["campioni"][keyCampione]["colore"]} />
																						{searchResult[keyMacrolotto]["sondaggi"][keySondaggio]["campioni"][keyCampione]["nome"]}
																					</NoWrap>
																				</td>
																				<TdTerreno>
																					{Object.keys(searchResult[keyMacrolotto]["sondaggi"][keySondaggio]["campioni"][keyCampione]["datiT"]).map((keyDato, iDato) =>
																						<React.Fragment key={keyDato}>{

																								keyDato === searchIdParametro ||
																								searchResult[keyMacrolotto]["sondaggi"][keySondaggio]["campioni"][keyCampione]["datiT"][keyDato]["colore"] === searchColorParametro
																							?
																								<div>
																									<Color color={searchResult[keyMacrolotto]["sondaggi"][keySondaggio]["campioni"][keyCampione]["datiT"][keyDato]["colore"]} />
																									{searchResult[keyMacrolotto]["sondaggi"][keySondaggio]["campioni"][keyCampione]["datiT"][keyDato]["nome"]} = {searchResult[keyMacrolotto]["sondaggi"][keySondaggio]["campioni"][keyCampione]["datiT"][keyDato]["valore"]}
																								</div>
																							:
																								null
																						}</React.Fragment>
																					)}
																				</TdTerreno>

																			</tr>
																			<tr>
																				<TdEluato>
																					{Object.keys(searchResult[keyMacrolotto]["sondaggi"][keySondaggio]["campioni"][keyCampione]["datiE"]).map((keyDato, iDato) => {
																						if(
																							keyDato === searchIdParametro ||
																							searchResult[keyMacrolotto]["sondaggi"][keySondaggio]["campioni"][keyCampione]["datiE"][keyDato]["colore"] === searchColorParametro
																						){
																							return <div key={iDato}>
																								<Color color={searchResult[keyMacrolotto]["sondaggi"][keySondaggio]["campioni"][keyCampione]["datiE"][keyDato]["colore"]} />
																								{searchResult[keyMacrolotto]["sondaggi"][keySondaggio]["campioni"][keyCampione]["datiE"][keyDato]["nome"]} = {searchResult[keyMacrolotto]["sondaggi"][keySondaggio]["campioni"][keyCampione]["datiE"][keyDato]["valore"]}
																							</div>
																						}else{
																							return null;
																						}
																					})}
																				</TdEluato>
																			</tr>
																		</React.Fragment>;
																})

															})}
														</React.Fragment>;
													})}
												</tbody>
											</ResultsTable>
										: <NoResult>Nessun risultato.</NoResult>
						}

					</SearchResults>

				</SearchPage>
				<LayersPage>
					<Topbar>
						<TopbarTitle>Layer mappa</TopbarTitle>
						<TopbarClose onClick={() => onClose()}><i className="fas fa-times" /></TopbarClose>
					</Topbar>
					<List>
						<Table>
							<tbody>
								<Macro
									onClick={() =>setShowListLv1(showListLv1.length > 0 ? [] : macrolotti)}
								>
									<Check active={showListLv1.length > 0}><i className="fas fa-check"></i></Check>
									<td colSpan="2">Macrolotti</td>
								</Macro>
								{macrolotti && Array.isArray(macrolotti) ? macrolotti.map((macrolotto, i) =>
									<tr
										key={i}
										onClick={() =>setShowListLv1(
											showListLv1.filter((item) => item.id === macrolotto.id).length > 0
												? showListLv1.filter((item) => item.id !== macrolotto.id)
												: [...showListLv1, macrolotto]
										)}
									>
										<Check active={showListLv1.filter((item) => item.id === macrolotto.id).length > 0}><i className="fas fa-check"></i></Check>
										<td>{macrolotto.siglaMacrolotto}</td>
										<td>{macrolotto.descrizione}</td>
									</tr>
								) : null}
								<Macro
									onClick={() =>setShowListLv2(showListLv2.length > 0 ? [] : subaree)}
								>
									<Check active={showListLv2.length > 0}><i className="fas fa-check"></i></Check>
									<td colSpan="2">Subaree</td>
								</Macro>

								{subaree ? subaree.map((subarea, i) =>
									<tr
										key={i}
										onClick={() =>setShowListLv2(
											showListLv2.filter((item) => item.id === subarea.id).length > 0
												? showListLv2.filter((item) => item.id !== subarea.id)
												: [...showListLv2, subarea]
										)}
									>
										<Check active={showListLv2.filter((item) => item.id === subarea.id).length > 0}><i className="fas fa-check"></i></Check>
										<td>{subarea.siglaSubarea}</td>
										<td>{subarea.nome}</td>
									</tr>
								) : null}
								<Macro>
									<td colSpan="3">Cartografie</td>
								</Macro>
								<tr
									onClick={() =>setShowListCartografie(
										showListCartografie.includes("ctr10k")
											? showListCartografie.filter((item) => item !== "ctr10k")
											: [...showListCartografie, "ctr10k"]
									)}
								>
									<Check active={showListCartografie.includes("ctr10k")}><i className="fas fa-check"></i></Check>
									<td colSpan="2">CTR10K Dataset coordinato</td>
								</tr>
								<tr
									onClick={() =>setShowListCartografie(
										showListCartografie.includes("ucs78")
											? showListCartografie.filter((item) => item !== "ucs78")
											: [...showListCartografie, "ucs78"]
									)}
								>
									<Check active={showListCartografie.includes("ucs78")}><i className="fas fa-check"></i></Check>
									<td colSpan="2">UCS78 scala 1:25.000</td>
								</tr>
								<tr
									onClick={() =>setShowListCartografie(
										showListCartografie.includes("cgt")
											? showListCartografie.filter((item) => item !== "cgt")
											: [...showListCartografie, "cgt"]
									)}
								>
									<Check active={showListCartografie.includes("cgt")}><i className="fas fa-check"></i></Check>
									<td colSpan="2">Carta geol. CGT WGS84</td>
								</tr>
								<Macro>
									<td colSpan="3">Mappa</td>
								</Macro>
								<tr onClick={() => setMapType("terrain")}>
									<Check active={mapType === "terrain"}><i className="fas fa-circle"></i></Check>
									<td colSpan="2">Terreno</td>
								</tr>
								<tr onClick={() => setMapType("satellite")}>
									<Check active={mapType === "satellite"}><i className="fas fa-circle"></i></Check>
									<td colSpan="2">Satellite</td>
								</tr>
								<tr onClick={() => setMapType("roadmap")}>
									<Check active={mapType === "roadmap"}><i className="fas fa-circle"></i></Check>
									<td colSpan="2">Stradale</td>
								</tr>
								<tr onClick={() => setMapType("hybrid")}>
									<Check active={mapType === "hybrid"}><i className="fas fa-circle"></i></Check>
									<td colSpan="2">Ibrida</td>
								</tr>
							</tbody>
						</Table>
					</List>
				</LayersPage>

			</Mover>
		</Wrapper>
  )
}

export default Side
